// FistOS control protocol — audio and video relay.
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
/**
 * Describes the file media.proto.
 */
export const file_media = /*@__PURE__*/ fileDesc("CgttZWRpYS5wcm90bxIJZmlzdG9zLnYxIngKCkF1ZGlvRnJhbWUSEQoJc3RyZWFtX2lkGAEgASgNEiwKCWRpcmVjdGlvbhgCIAEoDjIZLmZpc3Rvcy52MS5BdWRpb0RpcmVjdGlvbhILCgNzZXEYAyABKAQSDgoGcHRzX3VzGAQgASgEEgwKBG9wdXMYBSABKAwipQEKClZpZGVvRnJhbWUSEQoJc3RyZWFtX2lkGAEgASgNEiYKBnNvdXJjZRgCIAEoDjIWLmZpc3Rvcy52MS5WaWRlb1NvdXJjZRILCgNzZXEYAyABKAQSDgoGcHRzX3VzGAQgASgEEhAKCGtleWZyYW1lGAUgASgIEg4KBmFubmV4YhgGIAEoDBINCgV3aWR0aBgHIAEoDRIOCgZoZWlnaHQYCCABKA0iiAIKDE1lZGlhQ29udHJvbBIuCgxjYW1lcmFfc3RhcnQYASABKAsyFi5maXN0b3MudjEuQ2FtZXJhU3RhcnRIABIsCgtjYW1lcmFfc3RvcBgCIAEoCzIVLmZpc3Rvcy52MS5DYW1lcmFTdG9wSAASNgoQcmVxdWVzdF9rZXlmcmFtZRgDIAEoCzIaLmZpc3Rvcy52MS5SZXF1ZXN0S2V5ZnJhbWVIABIuCgxzY3JlZW5fc3RhcnQYBCABKAsyFi5maXN0b3MudjEuU2NyZWVuU3RhcnRIABIsCgtzY3JlZW5fc3RvcBgFIAEoCzIVLmZpc3Rvcy52MS5TY3JlZW5TdG9wSABCBAoCb3AiYQoLQ2FtZXJhU3RhcnQSEQoJY2FtZXJhX2lkGAEgASgJEg0KBXdpZHRoGAIgASgNEg4KBmhlaWdodBgDIAEoDRILCgNmcHMYBCABKA0SEwoLYml0cmF0ZV9icHMYBSABKA0iDAoKQ2FtZXJhU3RvcCJeCgtTY3JlZW5TdGFydBIWCg5tYXhfc2hvcnRfc2lkZRgBIAEoDRIVCg1tYXhfbG9uZ19zaWRlGAIgASgNEgsKA2ZwcxgDIAEoDRITCgtiaXRyYXRlX2JwcxgEIAEoDSIMCgpTY3JlZW5TdG9wIhEKD1JlcXVlc3RLZXlmcmFtZSpKCg5BdWRpb0RpcmVjdGlvbhIcChhBVURJT19ESVJFQ1RJT05fRE9XTkxJTksQABIaChZBVURJT19ESVJFQ1RJT05fVVBMSU5LEAEqPwoLVmlkZW9Tb3VyY2USFwoTVklERU9fU09VUkNFX0NBTUVSQRAAEhcKE1ZJREVPX1NPVVJDRV9TQ1JFRU4QAWIGcHJvdG8z");
/**
 * Describes the message fistos.v1.AudioFrame.
 * Use `create(AudioFrameSchema)` to create a new message.
 */
export const AudioFrameSchema = /*@__PURE__*/ messageDesc(file_media, 0);
/**
 * Describes the message fistos.v1.VideoFrame.
 * Use `create(VideoFrameSchema)` to create a new message.
 */
export const VideoFrameSchema = /*@__PURE__*/ messageDesc(file_media, 1);
/**
 * Describes the message fistos.v1.MediaControl.
 * Use `create(MediaControlSchema)` to create a new message.
 */
export const MediaControlSchema = /*@__PURE__*/ messageDesc(file_media, 2);
/**
 * Describes the message fistos.v1.CameraStart.
 * Use `create(CameraStartSchema)` to create a new message.
 */
export const CameraStartSchema = /*@__PURE__*/ messageDesc(file_media, 3);
/**
 * Describes the message fistos.v1.CameraStop.
 * Use `create(CameraStopSchema)` to create a new message.
 */
export const CameraStopSchema = /*@__PURE__*/ messageDesc(file_media, 4);
/**
 * Describes the message fistos.v1.ScreenStart.
 * Use `create(ScreenStartSchema)` to create a new message.
 */
export const ScreenStartSchema = /*@__PURE__*/ messageDesc(file_media, 5);
/**
 * Describes the message fistos.v1.ScreenStop.
 * Use `create(ScreenStopSchema)` to create a new message.
 */
export const ScreenStopSchema = /*@__PURE__*/ messageDesc(file_media, 6);
/**
 * Describes the message fistos.v1.RequestKeyframe.
 * Use `create(RequestKeyframeSchema)` to create a new message.
 */
export const RequestKeyframeSchema = /*@__PURE__*/ messageDesc(file_media, 7);
/**
 * @generated from enum fistos.v1.AudioDirection
 */
export var AudioDirection;
(function (AudioDirection) {
    /**
     * @generated from enum value: AUDIO_DIRECTION_DOWNLINK = 0;
     */
    AudioDirection[AudioDirection["DOWNLINK"] = 0] = "DOWNLINK";
    /**
     * @generated from enum value: AUDIO_DIRECTION_UPLINK = 1;
     */
    AudioDirection[AudioDirection["UPLINK"] = 1] = "UPLINK";
})(AudioDirection || (AudioDirection = {}));
/**
 * Describes the enum fistos.v1.AudioDirection.
 */
export const AudioDirectionSchema = /*@__PURE__*/ enumDesc(file_media, 0);
/**
 * @generated from enum fistos.v1.VideoSource
 */
export var VideoSource;
(function (VideoSource) {
    /**
     * @generated from enum value: VIDEO_SOURCE_CAMERA = 0;
     */
    VideoSource[VideoSource["CAMERA"] = 0] = "CAMERA";
    /**
     * Live screen for manual remote control (MediaControl.screen_start).
     *
     * @generated from enum value: VIDEO_SOURCE_SCREEN = 1;
     */
    VideoSource[VideoSource["SCREEN"] = 1] = "SCREEN";
})(VideoSource || (VideoSource = {}));
/**
 * Describes the enum fistos.v1.VideoSource.
 */
export const VideoSourceSchema = /*@__PURE__*/ enumDesc(file_media, 1);
